
        module.exports = __webpack_public_path__ + "assets/images/hero.f75e2c0e.jpg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 2400,
            height: 1600,
            type: "jpg",
            bytes: 446941,

            toString: function() {
                return src;
            }
        };
    